<template>
  <div class="contact">
    <div class="section-frame">
      <div class="page-sub-title">
        <h2>
          <i class="fa-title"></i>
          <div>{{ $t("contact") }}</div>
        </h2>
      </div>
      <div class="contact__row">
        <div class="contact__col col-4">
          <div class="contact__card">
            <p class="contact__card-title">
              <i class="fa-title"></i> <span>{{ $t("contact_for") }}</span>
            </p>
            <ul>
              <li>
                <a href="tel:+998981234567">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.30756 1.86908H15.5284C16.8928 1.86908 17.9997 2.71874 17.9997 3.76744V20.2325C17.9997 21.2809 16.8928 22.1311 15.5284 22.1311H8.30756C6.94259 22.1311 5.83594 21.2809 5.83594 20.2325V3.76744C5.83594 2.719 6.94259 1.86908 8.30756 1.86908ZM13.7834 2.89124H10.0514V3.9402H13.7834V2.89124ZM13.1842 20.9258H10.6528V19.8768H13.1842V20.9258ZM7.37934 18.5841H16.4555V5.11619H7.37934V18.5841Z"
                      fill="#be4e50"
                    />
                  </svg>

                  1355
                </a>
              </li>
              <li>
                <a href="mailto:info@universalbank.uz">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M19.366 7.80003C19.366 7.80003 13.3942 11.1582 12.166 11.1582C10.9942 11.1582 4.95703 7.73463 4.95703 7.73463V7.20003C4.95703 6.53763 5.49463 6.00003 6.15823 6.00003H18.1738C18.838 6.00003 19.3756 6.53763 19.3756 7.20003L19.366 7.80003ZM4.96663 9.60003C4.96603 9.60003 10.9942 12.8082 12.166 12.8082C13.4506 12.8082 19.366 9.60003 19.366 9.60003L19.3756 16.8C19.3756 17.4624 18.838 18 18.1738 18H6.15823C5.49523 18 4.95703 17.4624 4.95703 16.8L4.96663 9.60003Z"
                      fill="#be4e50"
                    />
                  </svg>

                  info@universalbank.uz
                </a>
              </li>
              <li>
                <a
                  href="https://www.google.com/maps/place/%D0%A2%D0%B0%D1%88%D0%BA%D0%B5%D0%BD%D1%82+100012/data=!4m2!3m1!1s0x38ae610fdde86057:0x5d82427cebe8749e?sa=X&ved=2ahUKEwj6_-LOxvjwAhUDmIsKHa6XCtcQ8gEwG3oECCoQAQ"
                  target="_blank"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 22C12 22 19.5 16 19.5 9.5C19.5 5.35785 16.1421 2 12 2C7.85785 2 4.5 5.35785 4.5 9.5C4.5 16 12 22 12 22Z"
                      fill="#be4e50"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M3.75 9.5C3.75 4.94364 7.44364 1.25 12 1.25C16.5564 1.25 20.25 4.94364 20.25 9.5C20.25 13.0158 18.2365 16.3116 16.3326 18.6599C15.3691 19.8482 14.4074 20.8257 13.6868 21.5062C13.3261 21.8469 13.0246 22.1143 12.8119 22.2976C12.7055 22.3893 12.6213 22.46 12.5629 22.5085C12.5336 22.5327 12.5108 22.5513 12.495 22.5643L12.4764 22.5793L12.4711 22.5836L12.4695 22.5849L12.4689 22.5853C12.4687 22.5855 12.4685 22.5857 12 22C11.5315 22.5857 11.5313 22.5855 11.5311 22.5853L11.5305 22.5849L11.5289 22.5836L11.5236 22.5793L11.505 22.5643C11.4892 22.5513 11.4664 22.5327 11.4371 22.5085C11.3787 22.46 11.2945 22.3893 11.1881 22.2976C10.9754 22.1143 10.6739 21.8469 10.3132 21.5062C9.59262 20.8257 8.63093 19.8482 7.66743 18.6599C5.76347 16.3116 3.75 13.0158 3.75 9.5ZM12 22L11.5315 22.5857C11.8054 22.8048 12.1946 22.8048 12.4685 22.5857L12 22ZM12 21.0155C12.1788 20.8581 12.4018 20.6567 12.6569 20.4157C13.3426 19.7681 14.2559 18.8393 15.1674 17.7151C17.0135 15.4384 18.75 12.4842 18.75 9.5C18.75 5.77206 15.7279 2.75 12 2.75C8.27206 2.75 5.25 5.77206 5.25 9.5C5.25 12.4842 6.98653 15.4384 8.83257 17.7151C9.74407 18.8393 10.6574 19.7681 11.3431 20.4157C11.5982 20.6567 11.8212 20.8581 12 21.0155Z"
                      fill="#be4e50"
                    />
                    <path
                      d="M12 12.5C13.6568 12.5 15 11.1568 15 9.5C15 7.84315 13.6568 6.5 12 6.5C10.3432 6.5 9 7.84315 9 9.5C9 11.1568 10.3432 12.5 12 12.5Z"
                      fill="white"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.25 9.5C8.25 7.42894 9.92894 5.75 12 5.75C14.0711 5.75 15.75 7.42894 15.75 9.5C15.75 11.5711 14.0711 13.25 12 13.25C9.92894 13.25 8.25 11.5711 8.25 9.5ZM12 7.25C10.7574 7.25 9.75 8.25736 9.75 9.5C9.75 10.7426 10.7574 11.75 12 11.75C13.2426 11.75 14.25 10.7426 14.25 9.5C14.25 8.25736 13.2426 7.25 12 7.25Z"
                      fill="white"
                    />
                  </svg>
                  <div>{{ $t("address") }}</div>
                </a>
              </li>
            </ul>
            <div class="contact__social">
              <a href="https://www.instagram.com/aristotle.uz/"
                ><img src="../assets/images/insta.svg" alt=""
              /></a>
              <a href="https://m.facebook.com/aristotle.uz/?ref=bookmarks"
                ><img src="../assets/images/facebook.svg" alt=""
              /></a>
              <a href="https://t.me/aristotleuz"
                ><img src="../assets/images/tg.svg" alt=""
              /></a>
            </div>
          </div>
        </div>
        <div class="contact__col col-8">
          <div class="contact__card">
            <p class="contact__card-title">
              <i class="fa-title"></i><span>{{ $t("leave_feedback") }}</span>
            </p>
            <form class="contact__form">
              <div class="contact__group">
                <input
                  type="text"
                  v-model="name"
                  :placeholder="$t('your_name')"
                />
                <div class="error" v-if="!$v.name.required && $v.name.$dirty">
                  <i>{{ $t("name_required") }}</i>
                </div>
              </div>
              <div class="contact__group">
                <input
                  type="email"
                  v-model="email"
                  :placeholder="$t('your_email')"
                />
                <div class="error" v-if="!$v.email.required && $v.email.$dirty">
                  <i>{{ $t("email_required") }}</i>
                </div>
                <div class="error" v-if="!$v.email.email && $v.email.$dirty">
                  {{ $t("email_invalid") }}
                </div>
              </div>
              <div class="contact__group full">
                <textarea
                  v-model="message"
                  :placeholder="$t('message_text')"
                ></textarea>
                <div
                  class="error"
                  v-if="!$v.message.required && $v.message.$dirty"
                >
                  <i>{{ $t("message_required") }}</i>
                </div>
              </div>
              <label class="user-form-sub">
                <input type="submit" @click.prevent="submitLogin" />
                <span>{{ $t("submit") }}</span>
                <i class="fa-telegram"></i>
              </label>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";

export default {
  title: "Aloqa",
  data() {
    return {
      name: null,
      email: null,
      message: null,
    };
  },
  validations: {
    name: {
      required,
    },
    email: {
      required,
      email,
    },
    message: {
      required,
    },
  },
  methods: {
    submitLogin() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      let data = {
        phone: null,
        email: this.email,
        first_name: this.name,
        message: this.message,
      };
      if (this.user) {
        data.phone = this.user.phone;
      }
      this.$store.dispatch("postContact", data);
      this.$v.$reset();
      this.email = null;
      this.name = null;
      this.message = null;
    },
  },
  computed: {
    lang() {
      return this.$store.getters.lang;
    },
    user() {
      return this.$store.getters.getUserCredentials;
    },
  },
};
</script>
